/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class MessageRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return this.store.findRecord('posts/text', params.post_id, {
      include: 'reactions,comments',
    });
  }
}
